export default {
    en: {
        translation: {
            'こんにちは！': 'Hello!',
        }
    },
}